import { Component, Input, OnChanges, SimpleChanges, ViewChild, ComponentRef, Injector, ApplicationRef, ComponentFactoryResolver } from '@angular/core';
import { Chart, TooltipItem, TooltipModel } from 'chart.js/auto';
import { GlobalVars } from '../../../../../../shared/global-vars';
import { TranslateService } from '@ngx-translate/core';
import { subDays, addMonths } from 'date-fns';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { OverlayPanel } from 'primeng/overlaypanel';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ModelService } from '../../../../../../shared/services/model.service';
import { AuthService } from '../../../../../../shared/services/auth.service';
import { UserInfo } from '../../../../../../shared/models/user-info';
import { ForecastScenario, MonthItem, PredictionItem, Seuil } from '../../../../../../shared/models/modal-graph-forecast';
import { SeuilService } from '../../../../../../shared/services/seuil.service';
import { PiezoDataService } from '../../../../../../shared/services/piezo-data.service';
import { ChartTooltipComponent } from '../../../../../desktop/core-desktop/components/model-headband/chart-tooltip/chart-tooltip.component';

@Component({
  selector: 'app-graph-forecast-mobile',
  templateUrl: './graph-forecast-mobile.component.html',
  styleUrl: './graph-forecast-mobile.component.scss'
})
export class GraphForecastMobileComponent {
  @Input() modelDataForecast: any;
  @Input() modelDataForecastLastest: any;
  @Input() modelDataObservation: any;
  @Input() modelSeuils: any;
  @Input() identifier: any;
  @Input() ipsPeriodesRetour: any;

  chart: any;
  selectedPeriodDays: number = 365;
  datasetLabels: { [key: string]: string } = {};
  predictionItems: PredictionItem[] = [];
  legendeItems: { label: string, selected: boolean}[] = [];
  ipsItems: { label: string, selected: boolean, showLegende: boolean }[] = [];
  monthItems: MonthItem[] = [];

  selectedCurves = [];
  loading: boolean = true;
  faSpinner = faCircleNotch;
  currentYear!: number;
  selectedDatasets: { [key: string]: boolean } = {};
  selectedMonthDatasets: ForecastScenario[] = [];

  colors = GlobalVars.colors;

  piezo: any[] = [];
  piezo_realtime: any[] = [];
  prev_NoRain: any[] = [];
  prev_10: any[] = [];
  prev_20: any[] = [];
  prev_50: any[] = [];
  prev_80: any[] = [];
  prev_90: any[] = [];

  months: any[] | undefined;

  selectedMonths: MonthItem | undefined;

  seuils: Seuil[] | undefined;
  seuilColors: { [key: string]: string } = {};

  infoForecast: string = "";

  userInfo: UserInfo | null = null;

  isPremium: boolean = false;

  selectedModelId: any;
  selectedResultId: any;
  selectedPiezo: string = '';

  descriptionModele: string = "";

  traductionName = {
    no_rain : 'NO_RAIN',
    ten_year_dry : 'TEN_YEAR_DRY',
    twenty_year_dry : 'TWENTY_YEAR_DRY',
    average : 'AVERAGE',
    five_year_wet : 'FIVE_YEAR_WET',
    ten_year_wet : 'TEN_YEAR_WET',
    piezo : 'PIEZO',
    piezo_realtime : 'PIEZO-REALTIME',
    ips_dix_ans_sec: 'IPS_TEN_YEAR_DRY',
    ips_cinq_ans_sec: 'IPS_FIVE_YEAR_DRY',
    ips_deux_ans_sec: 'IPS_TWO_YEAR_DRY',
    ips_mediane: 'IPS_AVERAGE',
    ips_deux_ans_hum: 'IPS_TWO_YEAR_WET',
    ips_cinq_ans_hum: 'IPS_FIVE_YEAR_WET',
    ips_dix_ans_hum: 'IPS_TEN_YEAR_WET',
    ips_sup_dix_ans_hum: 'IPS_SUP_TEN_YEAR_WET'
  }

  legendLabels = {
    Niveau : this.translate.instant('HEADBAND.MODELE.MODAL.GRAPH.LEGENDE_PIEZO_LEVEL'),
    Date: this.translate.instant('HEADBAND.MODELE.MODAL.GRAPH.LEGENDE_DATE')
  };

  keys = {
    prediction: [
      this.traductionName.ten_year_wet,
      this.traductionName.five_year_wet,
      this.traductionName.average,
      this.traductionName.twenty_year_dry,
      this.traductionName.ten_year_dry,
      this.traductionName.no_rain
    ],
    legende: [
      this.traductionName.piezo,
      this.traductionName.piezo_realtime
    ],
    ips: [
      this.traductionName.ips_dix_ans_sec,
      this.traductionName.ips_cinq_ans_sec,
      this.traductionName.ips_deux_ans_sec,
      this.traductionName.ips_mediane,
      this.traductionName.ips_deux_ans_hum,
      this.traductionName.ips_cinq_ans_hum,
      this.traductionName.ips_dix_ans_hum,
      this.traductionName.ips_sup_dix_ans_hum
    ]
  };

  availableScenarios: ForecastScenario[] = [];
  selectedScenario: ForecastScenario | undefined;
  hasScenario: boolean = false;

  ipsShow: boolean = false;
  ipsLabel: string = "";
  ips_dix_ans_sec: any[] = [];
  ips_cinq_ans_sec: any[] = [];
  ips_deux_ans_sec: any[] = [];
  ips_mediane: any[] = [];
  ips_deux_ans_hum: any[] = [];
  ips_cinq_ans_hum: any[] = [];
  ips_dix_ans_hum: any[] = [];

  modeZoom: boolean = false;
  showMonths: boolean = false;
  showCourbesOptions: boolean = false;

  private tooltipRef: ComponentRef<ChartTooltipComponent> | null = null;

  @ViewChild('graphActionsTemplate') graphActionsTemplate!: OverlayPanel;

  constructor(private translate: TranslateService,
              private modelService: ModelService,
              private authService: AuthService,
              private seuilService: SeuilService,
              private piezoDataService: PiezoDataService,
              private injector: Injector,
              private appRef: ApplicationRef,
              private componentFactoryResolver: ComponentFactoryResolver) {
    this.currentYear = new Date().getFullYear();
    this.externalTooltipHandler = this.externalTooltipHandler.bind(this);
  }

  ngOnInit(): void {
    Chart.register(zoomPlugin);

    this.authService.getUserInfo().subscribe(userInfo => {
      this.userInfo = userInfo;
      if (userInfo?.groupeUtilisateur){
        this.isPremium = userInfo.groupeUtilisateur.some(role => role.groupe.premium);
      }
    });

    this.initializeDatasetSelection();

    this.ipsLabel = this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.IPS_TO_SHOW`);
    this.ipsShow = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['modelDataForecast'] || changes['modelDataForecastLastest'] || changes['modelDataObservation'] || changes['modelSeuils'] || changes['identifier'] || changes['ipsPeriodesRetour']) &&
          this.modelDataForecast && this.modelDataForecastLastest && this.modelDataObservation && this.modelSeuils && this.identifier && this.ipsPeriodesRetour
    ) {
      this.loading = true;
      this.datasetLabels = {};
      this.predictionItems = [];
      this.legendeItems = [];
      this.monthItems = [];
      this.availableScenarios = [];
      this.selectedScenario = this.modelDataForecastLastest[0];

      if (this.modelDataForecastLastest.length > 1){
        this.initializeScenario();
      }

      this.initializeLabels();
      this.initializeDatasetSelection();
      this.filterDataByPeriod(this.selectedPeriodDays);

      this.selectedMonths = this.monthItems.find(item => item.modeleId === this.selectedScenario?.modeleId);
      if(this.selectedScenario){
        const anneePrelevements = this.selectedScenario.anneePrelevements > 1 ? `${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.ANNEE_PRELEV`)} ${this.selectedScenario.anneePrelevements}.` : this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.NO_ANNEE_PRELEV`);
        this.infoForecast = `${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.FORECAST_FOR`)} ${this.formatDate(this.selectedScenario?.dateDebut)} ${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.TO`)} ${this.formatDate(this.selectedScenario.dateFin)} - ${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.CALCUL_EFFECT`)} ${this.formatDate(this.selectedScenario.dateCalcul)}. ${anneePrelevements}`;
      }

      this.hasScenario = this.modelDataForecastLastest.length > 1;

      this.loading = false;
    }
  }

  initializeScenario() {
    this.modelDataForecastLastest.forEach((scenario: ForecastScenario) => {
      this.availableScenarios.push({
        id: scenario.id,
        modeleId: scenario.modeleId,
        dateFin: scenario.dateFin,
        dateDebut: scenario.dateDebut,
        dateCalcul: scenario.dateCalcul,
        anneePrelevements: scenario.anneePrelevements,
        scenarioPrelevements: this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.${scenario.scenarioPrelevements.toUpperCase()}`),
        labelScenario: this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.${scenario.scenarioPrelevements.toUpperCase()}`) + " ("+this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.BASE_TO`)+" "+scenario.anneePrelevements+")",
        serieResultatModele: scenario.serieResultatModele
      });
    });

    this.availableScenarios.sort((a, b) => a.id - b.id);
    this.selectedScenario = this.availableScenarios.find(item => item.scenarioPrelevements === "Moyen");
  }

  initializeSeuils() {
    if (this.modelSeuils && this.modelDataObservation) {
      const seuils = this.seuilService.initializeSeuils(this.modelSeuils, this.modelDataObservation);
      this.seuils = seuils;
      // Initialiser les couleurs pour chaque seuil
      this.seuils.forEach(seuil => {
        this.seuilColors[seuil.name] = seuil.color;
      });
    }
  }

  initializeForecast(){
    this.prev_NoRain = [];
    this.prev_10 = [];
    this.prev_20 = [];
    this.prev_50 = [];
    this.prev_80 = [];
    this.prev_90 = [];

    if(this.selectedScenario){
      const scenario = this.selectedScenario.serieResultatModele;
      scenario.forEach((element: { scenario: { libelle: any; }; date: any; value: any; }) => {
        switch (element.scenario.libelle) {
          case this.datasetLabels[this.traductionName.no_rain]:
            this.prev_NoRain.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          case this.datasetLabels[this.traductionName.ten_year_dry]:
            this.prev_10.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          case this.datasetLabels[this.traductionName.twenty_year_dry]:
            this.prev_20.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          case this.datasetLabels[this.traductionName.average]:
            this.prev_50.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          case this.datasetLabels[this.traductionName.five_year_wet]:
            this.prev_80.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          case this.datasetLabels[this.traductionName.ten_year_wet]:
            this.prev_90.push({
              "date" : element.date,
              "value" : element.value
            });
            break;
          default:
            break;
        }
      });
    }

    this.filterDataByPeriod(this.selectedPeriodDays);
  }

  initializeIPS() {
    if (this.ipsPeriodesRetour) {
      this.ips_dix_ans_sec = [];
      this.ips_cinq_ans_sec = [];
      this.ips_deux_ans_sec = [];
      this.ips_mediane = [];
      this.ips_deux_ans_hum = [];
      this.ips_cinq_ans_hum = [];
      this.ips_dix_ans_hum = [];

      // Définit un type pour restreindre les valeurs possibles de `ips.name`
      type PeriodeNames = "periodeRetour10ansSec" | "periodeRetour5ansSec" | "periodeRetour2ansSec" | "mediane" | "periodeRetour2ansHumide" | "periodeRetour5ansHumide" | "periodeRetour10ansHumide";

      // Crée la table de correspondance `mapPeriodes` avec le type explicitement défini
      const mapPeriodes: Record<PeriodeNames, any[]> = {
        "periodeRetour10ansSec": this.ips_dix_ans_sec,
        "periodeRetour5ansSec": this.ips_cinq_ans_sec,
        "periodeRetour2ansSec": this.ips_deux_ans_sec,
        "mediane": this.ips_mediane,
        "periodeRetour2ansHumide": this.ips_deux_ans_hum,
        "periodeRetour5ansHumide": this.ips_cinq_ans_hum,
        "periodeRetour10ansHumide": this.ips_dix_ans_hum
      };

      this.ipsPeriodesRetour.forEach((ips: { name: PeriodeNames; values: { month: number; value: any }[] }) => {
        const targetList = mapPeriodes[ips.name];
        if (targetList) {
          ips.values.forEach((data) => {
            const date = new Date(this.currentYear, data.month - 1, 1);
            targetList.push({
              "date": date.toUTCString(),
              "value": data.value
            });
          });
        }
      });

    }
  }

  initializeLabels() {
    // Fonction générique pour traiter les traductions
    const processKeys = (keysArray: string[], itemsArray: any[]) => {
      keysArray.forEach(key => {
        this.translate.get(`HEADBAND.MODELE.MODAL.GRAPH.${key}`).subscribe((translation: string) => {
          this.datasetLabels[key] = translation;
          itemsArray.push({ label: translation, selected: false, showLegende: true });
        });
      });
    };

    // Traitement des keysPrediction et keysLegende
    processKeys(this.keys.prediction, this.predictionItems);
    processKeys(this.keys.legende, this.legendeItems);
    processKeys(this.keys.ips, this.ipsItems);

    this.ipsItems.forEach(ips => {
      if (ips.label == this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.IPS_TWO_YEAR_WET`)) {
        ips.showLegende = false;
      }
    });

    // Ajouter dynamiquement les seuils
    if (this.seuils) {
      this.seuils.forEach(seuil => {
          this.legendeItems.push({ label: seuil.name, selected: false });
      });
    }

    if (this.selectedScenario) {
      const endDate = new Date(this.selectedScenario.dateFin);

      if (endDate) {
        this.modelDataForecast.forEach((forecast: {
          anneePrelevements: any;
          modeleId: any;
          id: any;
          dateCalcul: string;
          dateDebut: string;
          dateFin: string;
          scenarioPrelevements: string;
        }) => {

          this.translate.get(['HEADBAND.MODELE.MODAL.GRAPH.FORECAST_FOR', 'HEADBAND.MODELE.MODAL.GRAPH.TO']).subscribe((translations: any) => {
            const forecastFor = translations['HEADBAND.MODELE.MODAL.GRAPH.FORECAST_FOR'];
            const to = translations['HEADBAND.MODELE.MODAL.GRAPH.TO'];
            this.monthItems.push({
              id: forecast.id,
              modeleId: forecast.modeleId,
              anneePrelevements: forecast.anneePrelevements,
              label: `${forecastFor} ${this.formatDate(forecast.dateDebut)} ${to} ${this.formatDate(forecast.dateFin)}`,
              dateDebut: forecast.dateDebut,
              dateCalcul: forecast.dateCalcul,
              dateFin: forecast.dateFin
            });
          });
        });
      }
    }
  }

  initializeDatasetSelection() {
    if (this.selectedScenario && this.modelDataObservation) {

      if(this.selectedScenario) {
        this.selectedModelId = this.selectedScenario.modeleId;
        this.selectedResultId = this.selectedScenario.id;
      }

      const piezoData = this.piezoDataService.processPiezoData(this.modelDataObservation);
      this.piezo = piezoData.piezo;
      this.piezo_realtime = piezoData.piezoRealtime;
      this.initializeSeuils();
      this.initializeForecast();
      this.initializeIPS();

       // Mettez selectedDatasets à true si les tableaux correspondants ne sont pas vides
      this.selectedDatasets[this.datasetLabels[this.traductionName.no_rain]] = this.prev_NoRain.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ten_year_dry]] = this.prev_10.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.twenty_year_dry]] = this.prev_20.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.average]] = this.prev_50.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.five_year_wet]] = this.prev_80.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ten_year_wet]] = this.prev_90.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.piezo]] = this.piezo.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.piezo_realtime]] = this.piezo_realtime.length > 0;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_dix_ans_sec]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_cinq_ans_sec]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_deux_ans_sec]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_mediane]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_deux_ans_hum]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_cinq_ans_hum]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_dix_ans_hum]] = false;
      this.selectedDatasets[this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum]] = false;

      // Mettre à jour les seuils dynamiques
      if (this.seuils) {
        this.seuils.forEach(seuil => {
            this.selectedDatasets[seuil.name] = seuil.dataPoints.length > 0;
        });
      }

      this.updatePredictionItems();
    }
  }

  updatePredictionItems() {
    this.predictionItems = [];
    this.legendeItems = [];

    this.translateLabels(this.translate, this.keys.prediction, this.predictionItems);
    this.translateLabels(this.translate, this.keys.legende, this.legendeItems);

    // Ajouter dynamiquement les seuils
    if (this.seuils) {
      this.seuils.forEach(seuil => {
          this.legendeItems.push({ label: seuil.name, selected: seuil.dataPoints.length > 0 });
      });
  }

    this.predictionItems.forEach(item => {
      switch(item.label) {
        case this.datasetLabels[this.traductionName.no_rain]:
          item.selected = this.prev_NoRain.length > 0;
          break;
        case this.datasetLabels[this.traductionName.ten_year_dry]:
          item.selected = this.prev_10.length > 0;
          break;
        case this.datasetLabels[this.traductionName.twenty_year_dry]:
          item.selected = this.prev_20.length > 0;
          break;
        case this.datasetLabels[this.traductionName.average]:
          item.selected = this.prev_50.length > 0;
          break;
        case this.datasetLabels[this.traductionName.five_year_wet]:
          item.selected = this.prev_80.length > 0;
          break;
        case this.datasetLabels[this.traductionName.ten_year_wet]:
          item.selected = this.prev_90.length > 0;
          break;
        default:
          item.selected = false;
      }
    });

    this.legendeItems.forEach(item => {
      switch(item.label) {
        case this.datasetLabels[this.traductionName.piezo]:
          item.selected = this.piezo.length > 0;
          break;
        case this.datasetLabels[this.traductionName.piezo_realtime]:
          item.selected = this.piezo_realtime.length > 0;
          break;
        default:
          item.selected = this.seuils? this.seuils.some(seuil => seuil.name === item.label && seuil.dataPoints.length > 0) : false;
      }
    });
  }

  toggleDataset(label: string) {
    this.selectedDatasets[label] = !this.selectedDatasets[label];
    this.updateChart();
  }

  filterDataByPeriod(days: number, event?: Event) {
    if(event) {
      event.stopPropagation();
    }
    this.selectedPeriodDays = days;
    this.updateChart();
  }

  updateChart() {
    if (this.selectedScenario && this.modelDataObservation && this.modelDataObservation.length > 0) {
      const lastDate = this.modelService.getLastDate(this.modelDataObservation);
      const endDate = addMonths(lastDate || new Date(), 1);

      let startDate;
      if (this.selectedPeriodDays == 365) {
        startDate = new Date(this.currentYear, 0, 1);
      } else {
        startDate = subDays(lastDate || new Date(), this.selectedPeriodDays);
      }

      this.drawChart({ startDate, endDate });
    }
  }

  drawChart(range?: { startDate: Date; endDate: Date }) {
    if (this.chart) {
      this.chart.destroy();
    }

    const datasets = this.getDatasets(range);

    let ctx = document.getElementById('chartForecastModel') as HTMLCanvasElement;

    if (!ctx) {
      console.error('Failed to acquire chart context');
      return;
    }

    const labelToHide = this.datasetLabels[this.traductionName.ips_deux_ans_hum];

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: "",
            font: {
              size: 18
            }
          },
          legend: {
            display: false
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true,
              },
              drag: {
                enabled: this.modeZoom,
              },
              mode: 'xy'
            },
            pan: {
              enabled: true,
              mode: 'xy'
            },
            limits: {
              x: { min: 'original', max: 'original' },
              y: { min: 'original', max: 'original' }
            }
          },
          tooltip: {
            enabled: false, // Désactiver le tooltip par défaut
            external: (context) => this.externalTooltipHandler(context),
            filter: (tooltipItem) => tooltipItem.dataset.label !== labelToHide
          }
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        },
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'day',
              tooltipFormat: 'dd/MM/yyyy HH:mm:ss',
              displayFormats: {
                day: 'dd/MM/yyyy'
              }
            },
            title: {
              display: false,
              text: this.legendLabels.Date
            },
            display: false
          },
          y: {
            // display: false,
            // title: {
            //   display: true,
            //   text: this.legendLabels.Niveau
            // },
            grid: {
              drawOnChartArea: true,
            },
            ticks: {
              display: false,
            }
          }
        },
        layout : {
          padding: 0
        }
      }
    });
  }

  getDatasets(range?: { startDate: Date; endDate: Date }) {

    let allDatasets: any;

    allDatasets = [
      this.createDataset(this.datasetLabels[this.traductionName.piezo], this.piezo, this.colors.piezo, range),
      this.createDataset(this.datasetLabels[this.traductionName.piezo_realtime], this.piezo_realtime, this.colors.piezoRealtime, range)
    ];

    // Ajouter dynamiquement les datasets pour chaque seuil
    if (this.seuils) {
      this.seuils.forEach(seuil => {
          allDatasets.push(this.createDataset(seuil.name, seuil.dataPoints ?? [], seuil.color ?? "", range));
      });
    }

    allDatasets.push(
      this.createDataset(this.datasetLabels[this.traductionName.no_rain], this.prev_NoRain, this.colors.noRain, range),
      this.createDataset(this.datasetLabels[this.traductionName.ten_year_dry], this.prev_10, this.colors.tenYearDry, range),
      this.createDataset(this.datasetLabels[this.traductionName.twenty_year_dry], this.prev_20, this.colors.twentyYearDry, range),
      this.createDataset(this.datasetLabels[this.traductionName.average], this.prev_50, this.colors.average, range),
      this.createDataset(this.datasetLabels[this.traductionName.five_year_wet], this.prev_80, this.colors.fiveYearWet, range),
      this.createDataset(this.datasetLabels[this.traductionName.ten_year_wet], this.prev_90, this.colors.tenYearWet, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_dix_ans_sec], this.ips_dix_ans_sec, this.colors.ips_dix_ans_sec, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_cinq_ans_sec], this.ips_cinq_ans_sec, this.colors.ips_cinq_ans_sec, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_deux_ans_sec], this.ips_deux_ans_sec, this.colors.ips_deux_ans_sec, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_mediane], this.ips_mediane, this.colors.ips_mediane, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_deux_ans_hum], this.ips_deux_ans_hum, this.colors.ips_deux_ans_hum, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_cinq_ans_hum], this.ips_cinq_ans_hum, this.colors.ips_cinq_ans_hum, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_dix_ans_hum], this.ips_dix_ans_hum, this.colors.ips_dix_ans_hum, range),
      this.createDataset(this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum], this.ips_dix_ans_hum, this.colors.ips_sup_dix_ans_hum, range)
    );

    return allDatasets.filter((dataset: { label: string | number; }) => this.selectedDatasets[dataset.label]);
  }

  createDataset(label: string, data: any[], color: string, range?: { startDate: Date; endDate: Date }) {
    let endDate = new Date(this.currentYear, 12 - 1, 1);
    if(label == this.datasetLabels[this.traductionName.ips_dix_ans_sec] ||
      label == this.datasetLabels[this.traductionName.ips_cinq_ans_sec] ||
      label == this.datasetLabels[this.traductionName.ips_deux_ans_sec] ||
      label == this.datasetLabels[this.traductionName.ips_mediane] ||
      label == this.datasetLabels[this.traductionName.ips_deux_ans_hum] ||
      label == this.datasetLabels[this.traductionName.ips_cinq_ans_hum] ||
      label == this.datasetLabels[this.traductionName.ips_dix_ans_hum] ||
      label == this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum]){
        endDate = new Date(this.currentYear, 12 - 1, 1);
    } else if (range) {
      endDate = range.endDate;
    }

    const filteredData = range
      ? data.filter(d => {
          const date = new Date(d.date);
          return date >= range.startDate && date <= endDate;
        })
      : data;

    let borderDash: number[] = [];
    let stepped: boolean = false;
    let backgroundColor: string = "";
    let borderWidth: number = 2;
    let fill: string|undefined;

    if (label !== this.datasetLabels[this.traductionName.piezo] &&
        label !== this.datasetLabels[this.traductionName.piezo_realtime] &&
        !this.seuils?.some(seuil => seuil.name === label) &&
        label !== this.datasetLabels[this.traductionName.ips_dix_ans_sec] &&
        label !== this.datasetLabels[this.traductionName.ips_cinq_ans_sec] &&
        label !== this.datasetLabels[this.traductionName.ips_deux_ans_sec] &&
        label !== this.datasetLabels[this.traductionName.ips_mediane] &&
        label !== this.datasetLabels[this.traductionName.ips_deux_ans_hum] &&
        label !== this.datasetLabels[this.traductionName.ips_cinq_ans_hum] &&
        label !== this.datasetLabels[this.traductionName.ips_dix_ans_hum] &&
        label !== this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum]
      ) {
      borderDash = [10, 20];
      borderWidth = 1.5
    }

    if (this.seuils?.some(seuil => seuil.name === label)) {
      stepped = true;
      backgroundColor = this.hexToRgba(color, 0.25);
      fill = 'start';
    }

    if (label == this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum]) {
        fill =  'end';
        backgroundColor = this.hexToRgba(color, 0.75);
    } else if (label == this.datasetLabels[this.traductionName.ips_dix_ans_hum] ||
      label == this.datasetLabels[this.traductionName.ips_cinq_ans_sec] ||
      label == this.datasetLabels[this.traductionName.ips_deux_ans_sec] ||
      label == this.datasetLabels[this.traductionName.ips_mediane] ||
      label == this.datasetLabels[this.traductionName.ips_deux_ans_hum] ||
      label == this.datasetLabels[this.traductionName.ips_cinq_ans_hum]){
        fill =  '-1';
        backgroundColor = this.hexToRgba(color, 0.75);
      }else if (label == this.datasetLabels[this.traductionName.ips_dix_ans_sec]){
        fill =  'start';
        backgroundColor = this.hexToRgba(color, 0.75);
      }

    return {
      label: label,
      data: filteredData.map(d => ({ x: new Date(d.date), y: d.value })),
      borderColor: color,
      backgroundColor: backgroundColor,
      borderWidth: borderWidth,
      fill: fill ? fill : undefined,
      hidden: !this.selectedDatasets[label],
      pointRadius: 0.2,
      borderDash: borderDash,
      tension: 0.1,
      stepped: stepped
    };
  }

  getPredictionClass(label: string): string {
    switch (label) {
      case this.datasetLabels[this.traductionName.no_rain]: return 'color-no-rain';
      case this.datasetLabels[this.traductionName.ten_year_dry]: return 'color-10-dry';
      case this.datasetLabels[this.traductionName.twenty_year_dry]: return 'color-20-dry';
      case this.datasetLabels[this.traductionName.average]: return 'color-average';
      case this.datasetLabels[this.traductionName.five_year_wet]: return 'color-5-wet';
      case this.datasetLabels[this.traductionName.ten_year_wet]: return 'color-10-wet';
      case this.datasetLabels[this.traductionName.piezo]: return 'color-piezo';
      case this.datasetLabels[this.traductionName.piezo_realtime]: return 'color-piezo-realtime';
      case this.datasetLabels[this.traductionName.ips_dix_ans_sec]: return 'color-ips-dix-ans-sec';
      case this.datasetLabels[this.traductionName.ips_cinq_ans_sec]: return 'color-ips-cinq-ans-sec';
      case this.datasetLabels[this.traductionName.ips_deux_ans_sec]: return 'color-ips-deux-ans-sec';
      case this.datasetLabels[this.traductionName.ips_mediane]: return 'color-ips-mediane';
      case this.datasetLabels[this.traductionName.ips_deux_ans_hum]: return 'color-ips-deux-ans-hum';
      case this.datasetLabels[this.traductionName.ips_cinq_ans_hum]: return 'color-ips-cinq-ans-hum';
      case this.datasetLabels[this.traductionName.ips_dix_ans_hum]: return 'color-ips-dix-ans-hum';
      case this.datasetLabels[this.traductionName.ips_sup_dix_ans_hum]: return 'color-ips-sup-dix-ans-hum';
      default: return 'color-dynamic';
    }
  }

  onGraphActions(event: any): void {
    this.graphActionsTemplate.toggle(event);
  }

  onChange(event: any): void {
    this.changeForecast(event.value.modeleId, event.value.id);
    const anneePrelevements = event.value.anneePrelevements > 0 ? `${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.ANNEE_PRELEV`)} ${event.value.anneePrelevements}.` : this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.NO_ANNEE_PRELEV`);
    this.infoForecast = `${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.FORECAST_FOR`)} ${this.formatDate(event.value.dateDebut)} ${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.TO`)} ${this.formatDate(event.value.dateFin)} - ${this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.CALCUL_EFFECT`)} ${this.formatDate(event.value.dateCalcul)}. ${anneePrelevements}`;
    this.closeSelectMonths();
  }

  changeForecast(modeleId: any, resultId: any): void {
    this.selectedModelId = modeleId;
    this.selectedResultId = resultId;

    if (this.isPremium){
      this.modelService.getForecastByResultId(modeleId, resultId).subscribe((res) => {
        this.hasScenario = res.length > 1;
        this.selectedMonthDatasets = res;
        this.availableScenarios = [];

        res.forEach((scenario: ForecastScenario) => {
          this.availableScenarios.push({
            id: scenario.id,
            modeleId: scenario.modeleId,
            dateFin: scenario.dateFin,
            dateDebut: scenario.dateDebut,
            dateCalcul: scenario.dateCalcul,
            anneePrelevements: scenario.anneePrelevements,
            scenarioPrelevements: this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.${scenario.scenarioPrelevements.toUpperCase()}`),
            labelScenario: this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.${scenario.scenarioPrelevements.toUpperCase()}`) + " ("+this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.BASE_TO`)+" "+scenario.anneePrelevements+")",
            serieResultatModele: scenario.serieResultatModele
          });
        });

        this.availableScenarios.sort((a, b) => a.id - b.id);
        this.selectedScenario = this.availableScenarios.find(item => item.scenarioPrelevements === "Moyen") || this.availableScenarios[0];

        this.prev_NoRain = [];
        this.prev_10 = [];
        this.prev_20 = [];
        this.prev_50 = [];
        this.prev_80 = [];
        this.prev_90 = [];

        const scenario = this.selectedScenario?.serieResultatModele;
        scenario?.forEach((element: { scenario: { libelle: any; }; date: any; value: any; }) => {
          switch (element.scenario.libelle) {
            case this.datasetLabels[this.traductionName.no_rain]:
              this.prev_NoRain.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.ten_year_dry]:
              this.prev_10.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.twenty_year_dry]:
              this.prev_20.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.average]:
              this.prev_50.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.five_year_wet]:
              this.prev_80.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.ten_year_wet]:
              this.prev_90.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            default:
              break;
          }
        });
        this.filterDataByPeriod(this.selectedPeriodDays);
      });
    }
  }

  hexToRgba(hex: string, alpha: number): string {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  exportChart() {
    const currentDate = new Date().toISOString().slice(0, 10);

    // Générer l'URL de l'image à partir du chart
    const chartDataURL = this.chart.toBase64Image();

    // Créer un lien temporaire pour le téléchargement
    const link = document.createElement('a');
    link.href = chartDataURL;
    link.download = `prevision_${currentDate}.png`;

    // Simuler le clic pour déclencher le téléchargement
    link.click();
  }

  exportCSV() {
    if (this.isPremium) {
      this.modelService.downloadModelResult(this.selectedModelId, this.selectedResultId);
    }
  }

  translateLabels(translate: TranslateService, keys: string[], destinationArray: PredictionItem[]): void {
    keys.forEach(key => {
      translate.get(`HEADBAND.MODELE.MODAL.GRAPH.${key}`).subscribe((translation: string) => {
        destinationArray.push({ label: translation, selected: false });
      });
    });
  }

  trackByLabel(index: number, item: { label: string }) {
    return item.label;
  }

  onChangeScenario(event: any): void {
    this.changeScenario(event.value.modeleId, event.value.id);
  }

  changeScenario(modeleId: any, resultId: any): void {
    this.selectedModelId = modeleId;
    this.selectedResultId = resultId;

    this.modelService.getForecastByResultId(modeleId, resultId).subscribe((res) => {
      this.prev_NoRain = [];
      this.prev_10 = [];
      this.prev_20 = [];
      this.prev_50 = [];
      this.prev_80 = [];
      this.prev_90 = [];

      const scenarioItem  = res.find((item: { scenarioPrelevements: string | undefined; }) => item.scenarioPrelevements === this.selectedScenario?.scenarioPrelevements);
      if (scenarioItem) {
        const scenario = scenarioItem.serieResultatModele;
        scenario.forEach((element: { scenario: { libelle: any; }; date: any; value: any; }) => {
          switch (element.scenario.libelle) {
            case this.datasetLabels[this.traductionName.no_rain]:
              this.prev_NoRain.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.ten_year_dry]:
              this.prev_10.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.twenty_year_dry]:
              this.prev_20.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.average]:
              this.prev_50.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.five_year_wet]:
              this.prev_80.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            case this.datasetLabels[this.traductionName.ten_year_wet]:
              this.prev_90.push({
                "date" : element.date,
                "value" : element.value
              });
              break;
            default:
              break;
          }
        });
      }

      this.filterDataByPeriod(this.selectedPeriodDays);
    });
  }

  getDynamicColor(label: string): string {
    return this.seuilColors[label] || '';
  }

  toggleIps(){
    this.ipsShow = !this.ipsShow;
    this.ipsLabel = this.ipsShow? this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.IPS_TO_HIDDEN`) : this.translate.instant(`HEADBAND.MODELE.MODAL.GRAPH.IPS_TO_SHOW`);
    this.ipsItems.forEach(element => {
      this.toggleDataset(element.label);
    });
  }

  resetZoomBtn() {
    this.chart.resetZoom();
  }

  setModeZoom() {
    this.modeZoom = !this.modeZoom;
    this.chart.options.plugins.zoom.pan.enabled = !this.modeZoom;
    this.chart.options.plugins.zoom.zoom.drag.enabled = this.modeZoom;
    this.chart.update();
  }

  externalTooltipHandler = (context: { chart: any; tooltip: any; }) => {
    // Récupérer le canvas et le tooltip model
    const {chart, tooltip} = context;

    // Masquer le tooltip si aucune information à afficher
    if (tooltip.opacity === 0) {
      if (this.tooltipRef) {
        this.tooltipRef.instance.visible = false;
      }
      return;
    }

    // Si le tooltip n'existe pas encore, créer une instance
    if (!this.tooltipRef) {
      const factory = this.componentFactoryResolver.resolveComponentFactory(ChartTooltipComponent);
      this.tooltipRef = factory.create(this.injector);

      // Attacher le composant au DOM
      this.appRef.attachView(this.tooltipRef.hostView);
      const domElem = (this.tooltipRef.hostView as any).rootNodes[0] as HTMLElement;
      document.body.appendChild(domElem);
    }

    // Mise à jour des données dynamiques
    const tooltipCmp = this.tooltipRef.instance;

    // Construire les données pour le tooltip
    const legends = tooltip.dataPoints.filter((item: { dataset: { label: string | string[]; }; }) =>
      item.dataset?.label && (
        [this.datasetLabels[this.traductionName.piezo], this.datasetLabels[this.traductionName.piezo_realtime]].some(name => item.dataset.label?.includes(name)) ||
        this.seuils?.some(seuil => item.dataset.label?.includes(seuil.name))
      ));
    const predictions = tooltip.dataPoints.filter((item: { dataset: { label: string; }; }) =>
      item.dataset?.label && !(
        [this.datasetLabels[this.traductionName.piezo], this.datasetLabels[this.traductionName.piezo_realtime]].some(name => item.dataset.label?.includes(name)) ||
        this.seuils?.some(seuil => item.dataset.label?.includes(seuil.name)) ||
        item.dataset.label.startsWith("IPS - ")
      )
    ).reverse();
    const ips = tooltip.dataPoints.filter((item: { dataset: { label: string; }; }) =>
      item.dataset?.label && item.dataset.label.startsWith("IPS - ")
    );

    // Positionner le tooltip
    tooltipCmp.title = tooltip.title || [];
    tooltipCmp.legends = legends.map((item: { dataset: { label: any; borderColor: any; backgroundColor: any; }; raw: { y: number; }; }) => ({
      label: item.dataset.label,
      value: (item.raw as { y: number }).y,
      color: item.dataset.borderColor || item.dataset.backgroundColor,
    }));
    tooltipCmp.predictions = predictions.map((item: { dataset: { label: any; borderColor: any; backgroundColor: any; }; raw: { y: number; }; }) => ({
      label: item.dataset.label,
      value: (item.raw as { y: number }).y,
      color: item.dataset.borderColor || item.dataset.backgroundColor,
    }));
    tooltipCmp.ips = ips.map((item: { dataset: { label: any; borderColor: any; backgroundColor: any; }; raw: { y: number; }; }) => ({
      label: item.dataset.label,
      value: (item.raw as { y: number }).y,
      color: item.dataset.borderColor || item.dataset.backgroundColor,
    }));

    // Positionner le tooltip
    const position = chart.canvas.getBoundingClientRect();
    tooltipCmp.position = {
      left: position.left + window.pageXOffset + tooltip.caretX,
      top: position.top + window.pageYOffset + tooltip.caretY,
    };

    tooltipCmp.visible = true;
  }

  openSelectMonths(){
    this.showMonths = true;
  }

  closeSelectMonths(){
    this.showMonths = false;
  }

  openCourbesOptions(){
    this.showCourbesOptions = true;
  }

  closeCourbesOptions(){
    this.showCourbesOptions = false;
  }

  toggleCheckbox(prediction: any, event: MouseEvent): void {
    prediction.selected = !prediction.selected;
    this.toggleDataset(prediction.label);
  }

  handleCheckboxClick(prediction: any, event: MouseEvent): void {
    event.stopPropagation();
    this.toggleDataset(prediction.label);
  }
}
